import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './i18n';

// Creating and Defining new app and essentials.
const app = createApp(App).use(i18n).use(router);
app.mount('#app');
